<div class="card panel-flat-color secondary-panel annual-details">
    <div class="panel-flat-header">
        <div class="header-icon">
            <i class="fa fa-calendar fa-fw clickable" (click)="openParcelActivityModal()"></i>
        </div>
        <h3>Annual Details</h3>
        <div *ngIf="annualYearData" class="header-button-container ms-4 d-inline-block" style="vertical-align:top;">
            <add-year-modal [yearsList]="yearList"
                            [navigationState]="navigationState"
                            [parcelId]="parcelId"
                            [showButton]="!navigationState?.editMode"
                            *ngIf="navigationState?.hasWritePermission">
            </add-year-modal>
            <assessment-taxes-details-icon class="ms-2"
                                           [parcelId]="parcelId"
                                           [selectableYears]="vanillaYears">
            </assessment-taxes-details-icon>
        </div>
        <div class="float-end header-button-container" style="display: flex;">
            <span *ngIf="navigationState?.viewTarget !== ViewTarget.grid && !navigationState?.editMode && !!annualYearData">
                <button class="ace-btn btn-text has-icon"
                        tooltip="Back to Years"
                        container="body"
                        (click)="navigationState.goToGrid()"
                        style="margin-top:-1px; height: 24px; vertical-align: top;">
                    <i class="fa fa-arrow-left"></i>
                </button>
            </span>
            <span *ngIf="navigationState?.hasWritePermission && navigationState?.showEditControls && !!annualYearData">
                <span *ngIf="!navigationState.editMode">
                    <button class="ace-btn btn-text has-icon btn-primary" (click)="toggleEdit()">
                        <i class="fa fa-pencil" title="Edit"></i>
                    </button>
                </span>
                <span *ngIf="navigationState?.editMode">
                    <button class="ace-btn btn-text has-icon btn-primary btn-success"
                            (click)="saveEdit()"
                            tooltip="{{this.navigationState.validationMessage}}"
                            placement="left"
                            triggers="blur"
                            container="body"
                            [disabled]="!annualDetailsSaveAllowed"
                            #aDValidation="bs-tooltip">
                        <i class="fa fa-save" title="Save"></i>
                    </button>
                    <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancelEdit()">
                        <i class="fa fa-close" title="Cancel"></i>
                    </button>
                </span>
            </span>
            <button class="ace-btn btn-text has-icon btn-secondary" *ngIf="!maximize" (click)="maximize_click()">
                <i class="fa fa-arrows-alt" title="Expand"></i>
            </button>
            <button class="ace-btn btn-text has-icon btn-secondary" *ngIf="maximize" (click)="unmaximize_click()">
                <i class="fa fa-compress" title="Collapse"></i>
            </button>
        </div>
        <div class="clearfix"></div>
    </div>
    <!--<div class="panel-flat-body" [class.x-scroll]="!active.year" loading-spinner waiting-for="years" style="margin-top:-8px; height: 348px;">-->
    <div class="panel-flat-body large" *ngIf="navigationState && annualYearData" [ngSwitch]="navigationState.viewTarget" style="padding-bottom: 0;">
        <div class="col-lg-12" *ngSwitchCase="ViewTarget.grid">
            <annual-details-grid [navigationState]="navigationState"
                                 [components]="components"
                                 [years]="years"
                                 [componentTypes]="componentTypes"
                                 [filings]="filings"
                                 [filingTypes]="filingTypes"
                                 [hasComplianceResponsibility]="hasComplianceResponsibility"
                                 [hidden]="navigationState.entityLoading"
                                 [budgetsEnabled]="budgetsEnabled"
                                 [consolidatingTypeId]="consolidatingTypeId"
                                 [viewTaxableValues]="isViewTaxableValuesEnabled">
            </annual-details-grid>
            <div class="button-container" style="margin-top: 30px;" [hidden]="navigationState.entityLoading">
                <button class="ace-btn btn-primary show-all-years" (click)="getYearData(true)" *ngIf="this.totalYears > years?.length">
                    Show All Years
                </button>
            </div>
        </div>

        <div class="text-center" style="margin-top: 50px;" [hidden]="!navigationState.entityLoading">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>

        <div [hidden]="navigationState.viewTarget === ViewTarget.grid || navigationState.entityLoading" style="display:flex;">

            <div *ngIf="navigationState.viewTarget !== ViewTarget.grid" class="me-3" style="flex: 0 0 300px;">
                <annual-year [navigationState]="navigationState"
                             [currentYear]="navigationState.currentYear"
                             [currentAnnualDetailAssessment]="navigationState.currentRevision"
                             [componentTypes]="componentTypes"
                             [budgetsEnabled]="budgetsEnabled"
                             [consolidatingTypeId]="consolidatingTypeId"
                             [filingTypes]="filingTypes"
                             [viewTaxableValues]="isViewTaxableValuesEnabled">
                </annual-year>
            </div>

            <div *ngSwitchCase="ViewTarget.appeal" style="flex: 1">
                <appeal [viewModel]="navigationState.currentAppealVM"
                        [topLevelCompanyId]="topLevelCompanyId"
                        [currentYear]="navigationState.currentYear"
                        [currentRevision]="navigationState.currentRevision"
                        [assessmentNavigateHandler]="goToAssessment"
                        [editState]="navigationState"
                        (AnnualDetailsSaveAllowedChangedX)="annualDetailsSaveAllowedChanged($event)">
                </appeal>
            </div>
            <div *ngSwitchCase="ViewTarget.tax" style="flex: 1">
                <taxes [viewModel]="navigationState.currentTaxesVM"
                       [currentYear]="navigationState.currentYear"
                       [editState]="navigationState"
                       [hasCompanyCollectors]="hasCompanyCollectors"
                       [siteId]="siteId"
                       [gridNavigationHandler]="goToGrid"
                       [parcelID]="parcelId"
                       (AnnualDetailsSaveAllowedChangedX)="annualDetailsSaveAllowedChanged($event)">
                </taxes>
            </div>

            <div *ngSwitchCase="ViewTarget.assessment" style="flex: 1">
                <assessment [(viewModel)]="navigationState.currentAssessmentVM"
                            [currentYear]="navigationState.currentYear"
                            [componentTypes]="componentTypes"
                            [editState]="navigationState"
                            [propertyType]="propertyType"
                            [companyId]="companyId"
                            [gridNavigationHandler]="goToGrid"
                            (AssessmentChanged)="assessmentModelChange($event)"
                            [viewTaxableValues]="isViewTaxableValuesEnabled">
                </assessment>
            </div>
            <div *ngSwitchCase="ViewTarget.compliance" style="flex: 1">
                <compliance [viewModel]="navigationState.currentComplianceVM"
                            [currentYear]="navigationState.currentYear"
                            [editState]="navigationState"
                            [companyId]="companyId"
                            [topLevelCompanyId]="topLevelCompanyId"
                            [returnPreparationAllowed]="returnPreparationAllowed"
                            [filingTypes]="filingTypes">
                </compliance>
            </div>
            <div *ngSwitchCase="ViewTarget.budget" style="flex: 1">
                <annual-budget [viewModel]="navigationState.currentAnnualBudgetVM"
                               [currentYear]="navigationState.currentYear"
                               [editState]="navigationState">
                </annual-budget>
            </div>
        </div>
    </div>
    <div class="panel-flat-body" *ngIf="!navigationState">
        <div class="text-center" style="margin-top: 50px;">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>
    </div>
</div>
